import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { TCategoryItemScrollProps } from './definitions';
import Styles from './CategoryItemScroll.module.scss';
import { useFetchSearchProductData } from 'Pages/Home/Hooks/useFetchSearchProductData';
import Image from '../../Atoms/Image';
import { joinClassnames } from 'helpers/classNames';
import { useFetchCollectionData } from 'Pages/Home/Hooks/useFetchCollectionData';

function getCategoryNameByTitle(title: string) {
  switch (title.toLowerCase()) {
    case 'apparel':
      return 'apparels';
    case 'luxury':
      return 'handbags';
    default:
      return 'sneakers';
  }
}

export default function CategoryItemScroll({
  category,
  collectionCategory,
  slug,
}: TCategoryItemScrollProps) {
  const { data } = slug
    ? useFetchCollectionData(collectionCategory, slug, 8)
    : useFetchSearchProductData(getCategoryNameByTitle(category), 8, '');

  return (
    <div className={Styles['category-item-parent']}>
      <div
        className={joinClassnames(
          Styles['product-container'],
          Styles[`${category.toLowerCase()}`],
        )}
      >
        {data.map((item, index) => (
          <Image
            key={`product-image-${index}`}
            src={item.image}
            className={Styles['product-image']}
            type={item.category}
          />
        ))}
        {/* render the data once again to make infinite scroll */}
        {data.map((item, index) => (
          <Image
            key={`product-image-infinite-${index}`}
            src={item.image}
            className={Styles['product-image']}
          />
        ))}
      </div>
    </div>
  );
}
